import { render, staticRenderFns } from "./EdenPagination.vue?vue&type=template&id=7a1628a7"
import script from "./EdenPagination.vue?vue&type=script&lang=js"
export * from "./EdenPagination.vue?vue&type=script&lang=js"
import style0 from "./EdenPagination.vue?vue&type=style&index=0&id=7a1628a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports